// Main App component that mounts the router, providers, runtime, and routes.

import React from 'react';
import { BrowserRouter as Router } from 'react-router';
import { AppProviders } from './app/AppProviders';
import { AppRoutes } from './app/AppRoutes';
import { AppRuntime } from './app/AppRuntime';

const App: React.FC = () => {
  return (
    <Router>
      <AppProviders>
        <AppRuntime />
        <AppRoutes />
      </AppProviders>
    </Router>
  );
};

export default App;
